import React from 'react'
import { observer } from 'mobx-react-lite'

import { ImportScreen } from '../../ImportScreen'
import { YandexMarketProductImportTable } from '../../YandexMarketProductImportTable'

import { useYmAccount } from '../../../hooks/routeHooks'
import { useApi, useStore } from '../../../hooks/storeHook'

import { YandexMarketProductsTableData } from '../../../store/productStore'

import { YandexMarketProductColumnId } from '../../../types/yandexMarketColumns'
import { YandexMarketProductModel } from '../../../server/mpsklad_core/Models/YandexMarketProductModel'
import { YandexMarketAccountModel } from '../../../server/mpsklad_core/Models/YandexMarketAccountModel'
import { StoreProductsTableFilterColumn } from '../../../server/mpsklad_core/Models/StoreProductsTableFilterColumn'

export const YandexMarketImportPage =
  observer(
    () => {
      const api = useApi()
      const {productStore: {createYandexMarketProductsTable}} = useStore()
      const account = useYmAccount()

      const products = createYandexMarketProductsTable(account.id).setPropFilterReadOnly('hasMsProduct', true)

      return (
        <ImportScreen<YandexMarketAccountModel, YandexMarketProductsTableData, YandexMarketProductModel, YandexMarketProductColumnId, typeof StoreProductsTableFilterColumn>
          type="YandexMarket"
          account={account}
          products={products}
          addProductsFunc={api.import.importProductsYandexMarket}
          updateProductsFunc={api.import.updateProductsYandexMarket}
          importStocksFunc={api.import.importStocksYandexMarket}
          TableComponent={YandexMarketProductImportTable}
        />
      )
    })